export function mergeAndJoinFields(input = {}) {
  const {
    baseTable = [],
    joins = []
  } = input;

  if (!Array.isArray(baseTable)) {
    throw new TypeError("baseTable must be an array");
  }

  if (!Array.isArray(joins)) {
    throw new TypeError("joins must be an array");
  }

  return baseTable.map((baseRow) => {
    if (!baseRow || typeof baseRow !== "object") {
      return {};
    }

    const resultRow = { ...baseRow };

    for (const joinConfig of joins) {
      const {
        joinTable = [],
        correlation = [],
        fields = [],
        separator = ", "
      } = joinConfig || {};

      if (
        !Array.isArray(joinTable) ||
        !Array.isArray(correlation) ||
        correlation.length < 2 ||
        !Array.isArray(fields)
      ) {
        continue;
      }

      const [baseKey, joinKey] = correlation;

      const matchedJoinRow = joinTable.find(
        (joinRow) =>
          joinRow &&
          typeof joinRow === "object" &&
          joinRow[joinKey] === baseRow[baseKey]
      );

      for (const fieldConfig of fields) {
        const { name, fieldsToJoin = [] } = fieldConfig || {};

        if (!name || !Array.isArray(fieldsToJoin)) {
          continue;
        }

        if (!matchedJoinRow) {
          resultRow[name] = "";
          continue;
        }

        resultRow[name] = fieldsToJoin
          .filter((key) => Object.hasOwn(matchedJoinRow, key))
          .map((key) => matchedJoinRow[key])
          .filter((value) => value != null)
          .map((value) => String(value))
          .join(separator);
      }
    }

    return resultRow;
  });
}